import PropTypes from 'prop-types';

import passenger from './passenger';
import afterSalesRule from './afterSalesRule';

export default PropTypes.shape({
  afterSalesRules: PropTypes.arrayOf(afterSalesRule),
  afterSalesCurrentOverrides: PropTypes.arrayOf(afterSalesRule),
  itemRef: PropTypes.string,
  price: PropTypes.number,
  passenger,
  inventoryClass: PropTypes.string,
  name: PropTypes.string,
  cancelled: PropTypes.bool,
  provisional: PropTypes.bool,
  tariffDetails: PropTypes.shape({
    tariffCode: PropTypes.string,
    bucketCode: PropTypes.string
  })
});
